import { RootState } from 'editor/src/store/index';

import { isUsableRollLength, RollLengthBounds } from 'editor/src/util/gangSheet/rollingSheetLength';

// The rolling-sheet length limits, or undefined for a fixed-size sheet. The block crosses
// an origin boundary, so limits that cannot be honoured keep the sheet fixed.
const getRollLength = (state: RootState): RollLengthBounds | undefined => {
  const rollLength = state.hostSettings.gangSheet?.rollLength;
  return isUsableRollLength(rollLength) ? rollLength : undefined;
};

export default getRollLength;
